import React from 'react';
import classnames from 'classnames';
import { Stack } from '@servicetitan/design-system';
import styles from './touchscreen-pdf-viewer.less';

interface PdfViewerControlsProps {
    pageNumber: number;
    onClickPrevious: () => void;
    onClickNext: () => void;
    onClickZoomOut: () => void;
    onClickZoomIn: () => void;
}
export const PdfViewerControls: React.FC<PdfViewerControlsProps> = React.memo(
    ({ pageNumber, onClickPrevious, onClickNext, onClickZoomOut, onClickZoomIn }) => (
        <Stack
            alignItems="center"
            justifyContent="space-evenly"
            className={classnames('c-white', 'bg-black', styles.controlWrapper)}
        >
            <span
                className={classnames(styles.control, styles.pagePrevious)}
                onClick={onClickPrevious}
            />
            <span className={classnames(styles.control, styles.pageNext)} onClick={onClickNext} />
            <span className={classnames(styles.control, styles.pageNumber)}>{pageNumber}</span>
            <span
                className={classnames(styles.control, styles.zoomOut, 'p-b-half')}
                onClick={onClickZoomOut}
            />
            <span
                className={classnames(styles.control, styles.zoomIn, 'p-b-half')}
                onClick={onClickZoomIn}
            />
        </Stack>
    )
);
